"use strict";

exports.__esModule = true;
exports.createInflightRequestManager = void 0;

var createInflightRequestManager = function createInflightRequestManager() {
  var inflightRequests = {};
  return {
    getBeforeState: function getBeforeState(queryKey) {
      return inflightRequests[JSON.stringify(queryKey)];
    },
    set: function set(queryKey, result) {
      inflightRequests[JSON.stringify(queryKey)] = result;
    }
  };
};

exports.createInflightRequestManager = createInflightRequestManager;